import { TrendType } from '../../models/TransactionTrends'
import { statisticsType } from '../../static/data'

export interface Stats {
  salesVolume: string
  numOfTransactions: number
  successRate: string
  numOfRefunds: number
  numOfDisputes: number
}

export const getData = (items: TrendType[]): Stats => {
  const st = items.map((obj) => {
    return {
      salesVolume: obj.salesVolume,
      numOfTransactions: obj.numOfTransactions,
      successRate: obj.successRate,
      numOfRefunds: obj.numOfRefunds,
      numOfDisputes: obj.numOfDisputes,
    }
  })

  return st[0]
}

export const getHourlyStats = (statistics: any[]): Stats => {
  const h = statistics.filter((item: { type: string }) => item.type === statisticsType.Hourly)
  return getData(h)
}

const getDailyStats = (statistics: any[]): Stats => {
  const h = statistics.filter((item: { type: string }) => item.type === statisticsType.Daily)
  return getData(h)
}

const getWeeklyStats = (statistics: any[]): Stats => {
  const h = statistics.filter((item: { type: string }) => item.type === statisticsType.Weekly)
  return getData(h)
}

const getMonthlyStats = (statistics: any[]): Stats => {
  const h = statistics.filter((item: { type: string }) => item.type === statisticsType.Monthly)
  return getData(h)
}

const getYearlyStats = (statistics: any[]): Stats => {
  const h = statistics.filter((item: { type: string }) => item.type === statisticsType.Yearly)
  return getData(h)
}

const getDateStats = (statistics: any[]): Stats => {
  const h = statistics.filter((item: { type: string }) => item.type === statisticsType.Date)
  return getData(h)
}

type statsType = {
  [key: number]: Stats
}

export const getStatsByIndex = (value: number, statistics: any): Stats => {
  const getStatsObj: statsType = {
    0: getHourlyStats(statistics),
    1: getDailyStats(statistics),
    2: getWeeklyStats(statistics),
    3: getMonthlyStats(statistics),
    4: getYearlyStats(statistics),
    5: getDateStats(statistics),
  }

  return getStatsObj[value]
}
